module.exports = __webpack_public_path__ + "static/media/C16.c29a1db1.png";